import React from "react";
import { Link } from "gatsby-plugin-react-i18next";
import scientist1 from "../../assets/images/scientist/scientist1.png";
import shape3 from "../../assets/images/scientist/shape3.png";
import scientist2 from "../../assets/images/scientist/scientist2.png";
import shape2 from "../../assets/images/services/service-shape2.png";
import { useTranslation } from "gatsby-plugin-react-i18next";

const PBb = () => {
	const { t } = useTranslation();

	return (
		<div className="boxes-area pb-70">
			<div className="container">
				<div className="row">
					<div className="col-lg-4 col-md-6 col-sm-6">
						<div className="single-boxes-item">
							<div className="icon">
								<img src={scientist1} alt="banner" />
							</div>
							<h3>
								{t("home.PBbh31")}
								{/*
                                <Link to="/contact">
                                    Personal Branding
                                </Link>
                                */}
							</h3>
							<p>{t("home.PBbp1")}</p>

							{/*
                            <Link to="/Contact" className="default-btn">
                                <i className="flaticon-right"></i>
                                EN VOIR PLUS
                                <span></span>
                            </Link>
                            */}

							<div className="shape1">
								<img src={shape2} alt="banner" />
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-6 col-sm-6">
						<div className="single-boxes-item">
							<div className="icon">
								<img src={shape3} alt="banner" />
							</div>
							<h3>
								<Link to="/prequalification-rgpd-and-anonymous-candidacy">
									{t("home.PBbh32")}
								</Link>
							</h3>
							<p>{t("home.PBbp2")}</p>
							<Link to="/contact-direct" className="default-btn">
								<i className="flaticon-right"></i>
								{t("EnSavoirPlus")}
								<span></span>
							</Link>

							<div className="shape1">
								<img src={shape2} alt="banner" />
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-sm-3 offset-md-3">
						<div className="single-boxes-item">
							<div className="icon">
								<img src={scientist2} alt="banner" />
							</div>
							<h3>
								{t("home.PBbh33")}
								{/*
                                <Link to="/contactDirect">
                                    « Mon Réseau Privé »
                                </Link>
                                */}
							</h3>
							<p>{t("home.PBbp3")}</p>

							{/*
                            <Link to="/contactDirect" className="default-btn">
                                <i className="flaticon-right"></i>
                                EN VOIR PLUS
                                <span></span>
                            </Link>
                            */}

							<div className="shape1">
								<img src={shape2} alt="banner" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PBb;
